<template>
  <div class="vacancies-responses-header">
    <div>
      <h1 class="vacancies-responses-header__title">{{ $tMyResponses('My responses') }}</h1>
      <div
        v-if="isEmployer"
        class="vacancies-responses-header__phones-showed"
      >
        <div>
          <BaseSvg name="ico-eye-eyelashes" height="1.5rem" width="1.8rem" />
          <span>
            <span class="account-vacancies-responses__description-text">{{ $tMyResponses('Shown phones') }}: </span>
            <span class="ml-1">{{ phonesStats.shown }}</span>
          </span>
        </div>
        <div>
          <BaseSvg name="ico-eye-eyelashes-hide" height="1.1rem" width="1.8rem" />
          <span>
            <span class="account-vacancies-responses__description-text">{{ $tMyResponses('Available more') }}: </span>
            <span class="ml-1">{{ phonesStats.available }}</span>
          </span>
        </div>
      </div>
    </div>

    <div>
      <!--    TODO Export data temporary only for employers    -->
      <div
        v-if="isEmployer"
        class="vacancies-responses-header__phones-showed-data-export"
      >
        <div v-if="isEmployer">
          <div>
            <BaseSvg name="ico-eye-eyelashes" height="1.5rem" width="1.8rem" />
            <span class="ml-2">{{ phonesStats.shown }}</span>
          </div>
          <div class="ml-5">
            <BaseSvg name="ico-eye-eyelashes-hide" height="1.1rem" width="1.8rem" />
            <span class="ml-2">{{ phonesStats.available }}</span>
          </div>
        </div>
        <button class="base-btn base-btn--small vacancies-responses-header__btn-data-export" @click="onDataExportClick">
          <BaseSvg name="ico-exit-out" width="1.7rem" height="1.5rem" />
          <span>{{ $tMyResponses('Data export') }}</span>
        </button>
      </div>

      <div class="vacancies-responses-header__sort-and-filters">
        <BaseMenu ref="filtersMenu" :card-style="filtersMenuStyle">
          <template v-slot:activator="{ on }">
            <VacanciesResponsesFilterSelector
              :value="$tMyResponses('Job filter')"
              :filters-count="activeFilters.length"
              v-on="on"
              @clear="dropFilters"
            />
          </template>

          <div class="account-vacancies-responses__menu-inputs-list">
            <BaseCheckbox
              v-for="(filter, index) in filters"
              :key="index"
              color="#3674ED"
              :label="filter.title"
              :checked="isCheckedInCheckboxesList(activeFilters, filter)"
              @input="bindWithCheckboxesList(activeFilters, $event, filter); compareCheckedRouteFilter(filter, $event)"
            />
          </div>
          <button
            class="base-btn base-btn--outline-dark base-btn--x-small"
            @click="dropFilters"
          >
            {{ $tMyResponses('Reset') }}
          </button>
        </BaseMenu>

        <BaseSelect
          v-model="sortType"
          text-key="title"
          class="vacancies-responses-header__sort-select"
          :options="sortTypes"
          @input="updateVacancies"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VacanciesResponsesFilterSelector from './VacanciesResponsesFilterSelector';
import windowSizeMixin from '../../mixins/windowSizeMixin';

const DEFAULT_SORTING = 'created_at';

export default {
  name: 'VacanciesResponsesHeader',
  components: {
    VacanciesResponsesFilterSelector,
  },
  mixins: [windowSizeMixin],
  computed: {
    ...mapGetters('user', [
      'isEmployer',
    ]),
    ...mapGetters('vacancies/responses', {
      filters: 'filtersList',
    }),

    filtersMenuStyle() {
      return {
        width: this.mdOrDown ? '100%' : '120%',
        transform: `translate(${this.mdOrDown ? '0' : '-16.34%'}, -50%)`,
        maxWidth: 'calc(100vw - 4%)',
        padding: '2rem 2.2rem',
        minWidth: 'unset',
      };
    },
    sortTypes() {
      return [
        { title: this.$tMyResponses('By date of publication'), value: DEFAULT_SORTING },
        { title: this.$tMyResponses('By update date'), value: 'updated_at' }
      ];
    },
    dataExportItems() {
      return [
        { label: this.$tMyResponses('Name'), value: 'name' },
        { label: this.$tMyResponses('Gender'), value: 'gender' },
        { label: this.$tMyResponses('Age'), value: 'age' },
        { label: this.$tMyResponses('Phone number'), value: 'phone' },
        { label: this.$tMyResponses('Location'), value: 'place' },
        { label: this.$tMyResponses('Notes'), value: 'note' },
      ];
    },
  },
  data() {
    return {
      activeFilters: [],
      sortType: null,
      phonesStats: {
        shown: '-',
        available: '-',
      },
    };
  },
  async created() {
    if (this.isEmployer) {
      this.loadPhonesStats();
    }
    await this.loadFilters();
    await this.setDefaultSortType();
    await this.updateVacancies();
  },
  watch: {
    activeFilters() {
      this.applyFilters();
    },
  },
  methods: {
    ...mapActions('vacancies/responses', [
      'load',
      'loadFilters',
      'exportData',
      'getPhonesStats',
    ]),

    bindWithCheckboxesList(list, checked, value) {
      if (checked) list.push(value);
      else {
        const idx = list.findIndex(el => el.id === value.id);
        list.splice(idx, 1);
      }
    },
    isCheckedInCheckboxesList(list, value) {
      return !!list.find(el => el.id === value.id);
    },

    loadPhonesStats() {
      this.getPhonesStats()
        .then(({ phone_views, phone_remaining }) => {
          this.phonesStats = { shown: phone_views, available: phone_remaining };
        })
        .catch(() => {});
    },

    updateVacancies() {
      const vacancy_ids = [...this.activeFilters];
      this.addQueryVacancyFilter(vacancy_ids);
      this.load({ vacancy_ids, sort: this.sortType.value });
    },
    addQueryVacancyFilter(list) {
      const id = this.$route.query.vacancy_id;
      if (!id) return false;

      const queryParamFilter = f => f.id === Number(id);
      const filter = this.filters.find(queryParamFilter);
      const alreadyActiveFilter = this.activeFilters.find(queryParamFilter);
      if (filter && !alreadyActiveFilter) {
        list.push(filter);
        this.bindWithCheckboxesList(this.activeFilters, true, filter);
      }
      return !this.sameListsIds(this.activeFilters, list);
    },
    sameListsIds(list, list2) {
      return list.every(f => list2.find(fl => fl.id === f.id)) && list2.every(f => list.find(fl => fl.id === f.id));
    },
    removeQueryParamFilter() {
      const query = {...this.$route.query};
      delete query.vacancy_id;
      this.$router.push({ query }).catch(() => {});
    },
    compareCheckedRouteFilter(filter, checked) {
      const routeFilterId = this.$route.query.vacancy_id;
      if (!checked && filter.id === Number(routeFilterId)) {
        this.removeQueryParamFilter();
      }
    },

    applyFilters() {
      this.updateVacancies();
    },
    dropFilters() {
      this.removeQueryParamFilter();
      this.activeFilters = [];
      this.applyFilters();
      this.$refs.filtersMenu.close();
    },

    setDefaultSortType() {
      this.sortType = this.sortTypes.find(t => t.value === DEFAULT_SORTING)
    },

    onDataExportClick() {
      this.$vModal.open('data-export', {
        title: this.$tMyResponses('To export data'),
        text: this.$tMyResponses('Please choose fields to export'),
        checkboxes: this.dataExportItems,
        onDownloadClick: this.onDataExportDownloadClick,
      });
    },
    async onDataExportDownloadClick({ activeCheckboxes }) {
      const fields = activeCheckboxes.map(c => c.value);
      await this.exportData({ fields });
      this.$vModal.close('data-export');
    },
  },
};
</script>
